import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";
import { AxiosError } from "axios";

type UpdateCustomFieldsErrorResponse = {
  error?: string;
};

type UpdateCustomFieldsRequest = {
  leaseId: string;
  payload: { customFields: unknown };
};

const updateCustomFieldsRequest = async ({ leaseId, payload }: UpdateCustomFieldsRequest) => {
  const url = `${apiV1Endpoint}/booking/customfields/${leaseId}`;

  const response = await axios.patch<ApiResponse>(url, payload);
  return response.data.result;
};

type UseUpdateCustomFieldsOptions = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ApiResponse>) => void;
};

export const useUpdateCustomFields = (options: UseUpdateCustomFieldsOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateCustomFieldsRequest,
    onSuccess,
    onError,
  });

  return {
    updateCustomFieldsRequest: mutateAsync,
    isPendingUpdateCustomFields: isPending,
  };
};
